// extracted by mini-css-extract-plugin
module.exports = {"TextWrapperBox":"JobDescription_TextWrapperBox__3Ijg1","title":"JobDescription_title__A0j1-","subTitle":"JobDescription_subTitle__3fBJb"};